// extracted by mini-css-extract-plugin
export default {"publishDialog":"styles_publishDialog__Ogkms"};